import { render, staticRenderFns } from "./ProjectReportsEmailTable.vue?vue&type=template&id=248960bb&scoped=true&"
import script from "./ProjectReportsEmailTable.vue?vue&type=script&lang=js&"
export * from "./ProjectReportsEmailTable.vue?vue&type=script&lang=js&"
import style0 from "./ProjectReportsEmailTable.vue?vue&type=style&index=0&id=248960bb&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248960bb",
  null
  
)

export default component.exports